import * as React from 'react'

import { cn } from '~/styled'

import { Heading } from '../heading/Heading'

export const DialogHeading = ({
  className,
  ...rest
}: React.ComponentProps<typeof Heading>) => (
  <Heading
    size="sm"
    {...rest}
    className={cn(
      'border-b',
      'border-b-grey-200',
      'pb-8',
      'pt-0',
      'px-8',
      'mb-8',
      '-mx-8',
      'box-content',
      className
    )}
  />
)
